export default {
  title: {
    fontFamily: 'TheOutnetWebXL'
  },
  preTitle: {
    fontFamily: 'TheOutnetWebXL',
    margin: '0 0 16px'
  },
  contentContainerStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0 24px 16px',
    'screen-large': {
      padding: '32px 112px'
    }
  },
  additionalBackgroundPictureStyles: {
    height: '454px',
    'screen-large': {
      height: '400px'
    }
  }
}
